import React from 'react';
import '@inovando/react-components/dist/index.css';
import DialogForm from 'components/DialogForm';

import { Form } from 'react-final-form';
import { Field } from 'react-final-form';
import { Checkbox as MuiCheckbox } from '@mui/material';

import styled from 'styled-components';

import {
  Box,
  FormControl,
  FormControlLabel,
  FormGroup,
  Typography,
} from '@mui/material';
import MUIButton from '@mui/material/Button';

const SubmitButton = styled(MUIButton)`
  text-transform: none;
`;

const DialogDescription = styled(Typography)`
  font-size: 15px;
  color: #8b8b8b;
  margin-bottom: 10px;
`;

function DebitoContaDialog({ onSubmit, open, onClose, isReorg}: any) {
  return (
    <div>
      <DialogForm
        id="debito_form"
        onClose={onClose}
        open={open}
        title="Pagamento das parcelas"
      >
        {() => (
          <Form
            onSubmit={onSubmit}
            initialValues={{
              debitoConta: isReorg,
              chequeEspecial: false,
            }}
            render={({ handleSubmit, submitting, values }: any) => (
              <form onSubmit={handleSubmit} noValidate>
                <DialogDescription>
                  {
                    isReorg ? "Para a sua comodidade, caso não haja saldo em conta no dia do débito das suas parcelas, você tem as alternativas abaixo:" :
                  "Selecione uma ou nenhuma das opções!"
                  }
                  
                </DialogDescription>
                <FormControl required component="fieldset">
                  <FormGroup>
                    <Field
                      name="debitoConta"
                      type="checkbox"
                    >
                      {({ input }) => (
                        <FormControlLabel
                          control={
                            <MuiCheckbox
                              {...input}
                              checked={input.checked}
                              disabled={isReorg}
                            />
                          }
                          label={isReorg ? "Autorizo novas tentativas de débito da parcela usando o saldo disponível em conta" : "Deseja que as demais parcelas sejam débito em conta?" }
                        />
                      )}
                    </Field>

                    <Field
                      name="chequeEspecial"
                      type="checkbox"
                    >
                      {({ input }) => (
                        <FormControlLabel
                          control={
                            <MuiCheckbox
                              {...input}
                              checked={input.checked}
                            />
                          }
                          label={isReorg ? "Autorizo o débito da parcela usando o limite de crédito disponível em conta (1)" : "Aceita que use o cheque especial?"}
                        />
                      )}
                    </Field>
                  </FormGroup>
                </FormControl>
                {isReorg && (
                  <Box mt={2.5}>
                    <Typography>
                      <strong>Aviso</strong>
                    </Typography>
                    <DialogDescription>
                      (1) Condição válida caso haja limite disponível. A concessão do limite está sujeita à análise de crédito.
                    </DialogDescription>
                  </Box>
                )}
                <Box my={2}>
                  <SubmitButton
                    variant="contained"
                    color="primary"
                    fullWidth
                    type="submit"
                    disabled={submitting || (isReorg && !values.debitoConta)}
                    size="large"
                  >
                    <span>Firmar acordo</span>
                  </SubmitButton>
                </Box>
              </form>
            )}
          />
        )}
      </DialogForm>
    </div>
  );
}

export default DebitoContaDialog;
